import { render, staticRenderFns } from "./ReturnHistory.vue?vue&type=template&id=dc27a11a&scoped=true&"
import script from "./ReturnHistory.vue?vue&type=script&lang=js&"
export * from "./ReturnHistory.vue?vue&type=script&lang=js&"
import style0 from "./ReturnHistory.vue?vue&type=style&index=0&id=dc27a11a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc27a11a",
  null
  
)

export default component.exports